// Bra sizing reference tables and conversion data.
// Sources: standard US/UK/EU sizing charts (Wacoal, M&S, ThirdLove published guides).

export type SizingSystem = "US" | "UK" | "EU";

// US cup ladder by inches difference (bust - band)
// Indexed by Math.round(diff) clamped 0..12
export const US_CUPS = [
  "AA", "A", "B", "C", "D", "DD", "DDD", "G", "H", "I", "J", "K", "L",
];

// UK cup ladder — diverges from US after DD
export const UK_CUPS = [
  "AA", "A", "B", "C", "D", "DD", "E", "F", "FF", "G", "GG", "H", "HH",
];

// EU/International cup ladder — every 2 cm difference = 1 cup
export const EU_CUPS = [
  "AA", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L",
];

// EU band sizes are underbust rounded to nearest 5 cm
export const EU_BAND_STEP = 5;

// Common US bands (inches)
export const US_BANDS = [28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48];

// EU bands typical
export const EU_BANDS = [60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110];
